import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import { ColorService } from '@zaoblako/web/core/services/color.service';
import { DeepPartial } from '@zaoblako/web/core/types/deep-partial';
import { FileUrlPipe } from '@zaoblako/web/shared/pipes/file-url.pipe';
import { ApiUrlPipe } from '@zaoblako/web/shared/pipes/api-url.pipe';
import { AvatarModule } from 'primeng/avatar';
import uniqolor from 'uniqolor';

@Component({
  standalone: true,
  selector: 'crm-user-avatar',
  templateUrl: './user-avatar.component.html',
  imports: [CommonModule, AvatarModule, FileUrlPipe, ApiUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAvatarComponent implements OnInit {
  @Input() public user: DeepPartial<ProfileFindInterface> | DeepPartial<UserFindInterface>;
  @Input() public size: 'normal' | 'large' | 'xlarge' | undefined = 'large';
  @Input() public shape: 'circle' | 'square' = 'square';

  @Input() public showAdminIcon: boolean = false;

  public backgroundColor: string;

  public get userLabel() {
    const profile = (<DeepPartial<UserFindInterface>> this.user)?.profile
      ? (<DeepPartial<UserFindInterface>> this.user)?.profile
      : this.user as DeepPartial<ProfileFindInterface>;

    const [secondName, firstName] = (profile?.name || '').split(' ');
    return (secondName ? secondName[0] : '') + (firstName ? firstName[0] : '');
  }

  public get file(): FileFindInterface {
    const profile = (<DeepPartial<UserFindInterface>> this.user)?.profile
      ? (<DeepPartial<UserFindInterface>> this.user)?.profile
      : this.user as DeepPartial<ProfileFindInterface>;
    return profile?.file as FileFindInterface;
  }

  public constructor(public readonly colorService: ColorService) {}

  public ngOnInit() {
    const profile = (<DeepPartial<UserFindInterface>> this.user)?.profile
      ? (<DeepPartial<UserFindInterface>> this.user)?.profile
      : this.user as DeepPartial<ProfileFindInterface>;
    this.backgroundColor = uniqolor(`${profile?.name}-${this.user?.id}`)?.color;
  }
}
